var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBigCheck = function SvgBigCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "26_Signup_Success",
    transform: "translate(-852.000000, -278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window",
    transform: "translate(300.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right_Col",
    transform: "translate(360.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(192.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#01FF6C",
    cx: 21,
    cy: 21,
    r: 21
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-39",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    points: "13.3300781 21.1572729 20.3130385 27.8613281 30.6108398 15.9663086"
  }))))))));
};
export default SvgBigCheck;